import type { EnrollmentStatus } from '../api/types';
import { statusLabels } from './enrollmentLabels';

/** One status, drawn the same way wherever it appears — the employee's own view and HR's list. */
export function EnrollmentStatusBadge({ status }: { status: EnrollmentStatus }) {
  return <span className={`care-badge care-badge--${status}`}>{statusLabels[status]}</span>;
}
